export const ORDER_OPTIONS_DEFAULTS = {
  macro_categories: ["Stampa 3D", "Progettazione", "Entrambe"],
  no_material_categories: ["Progettazione"],
  materials: [
    "Portaimpronte individuale",
    "Prototipo calcinabile",
    "Bite prototipato",
    "Provvisorio",
    "Provino plastico prototipato",
    "Base protesi totale",
    "Dima chirurgica",
    "Composito definitivo",
    "Ceramica stampata",
  ],
  colors: ["BL1", "BL2", "BL3", "BL4", "A1", "A2", "A3", "A3.5", "A4", "B1", "B2", "B3", "B4", "C1", "C2", "C3", "C4", "D2", "D3", "D4"],
  quantities: ["1", "2", "3", "4", "5", "6", "7", "8", "Arcata superiore", "Arcata inferiore", "Doppia arcata"],
  design_types: ["Corona", "Ponte", "Intarsio / Onlay", "Faccetta", "Barra su impianti", "Scheletrato", "Provvisorio", "Dima chirurgica", "Modello studio"],
  deadline_days: { stampa_3d: 1, progettazione_1_4: 2, progettazione_5_plus: 3, toronto: 5 },
};
